export default "__VITE_ASSET__cea7c15c__"